export default {
    Applicantpro: 'AP',
    Avature: 'AV',
    Beamery: 'BM',
    Comeet: 'CT',
    GreenHouse: 'GH',
    Gr8People: 'GR',
    Jobvite: 'JV',
    Lever: 'LV',
    Pandologic: 'PL',
    Phenom: 'PH',
    SuccessFactors: 'SF',
    Telemetry: 'TL',
    Workday: 'WD',
    Paycor: 'PC',
};
